<template>
  <div class="form-group" style="position: relative" v-if="IsShow">
    <h5 class="CPSForm-label" :class="{ floatedLabel: floatedLabel || $attrs['placeholder'] || (temp_value===0) || temp_value }"
      v-if="labelText">
      {{ $t(labelText)
      }}<span class="text-danger" v-if="isHideStar === true
    ? !isHideStar
    : validationRules
      ? validationRules.required
      : validationRules
  ">
        *</span>
    </h5>
    <validation-provider Name="Name" :rules="validationRules" v-slot="validationContext"
      :vid="ControlId ? ControlId : vid" ref="validationState" :custom-messages="{email: $t('Lbl_EmailFormatError'), min_value: $t('lbl_EMPBE_CantSmallerThan1')}">
      <b-form-input ref="input" v-model="temp_value" :id="vid" @input="updateValue" @change="updateValue" @focus="focusInput" @blur="checkValue"
        :state="getValidationState(validationContext)" v-bind="$attrs" :style="inputStyle" class="CPSForm-input"
        @animationstart="checkValue" :type="type" :disabled="disabled" @keydown="handleKeydown" @paste="handlePaste"></b-form-input>
      <!-- [wxy][20230921] 添加password右边的眼睛icon，可以查看输入的密码 -->
      <div class="pwd_tips" v-if="type === 'password'"
        :class="{ 'fa fa-eye': showPassword, 'fa fa-eye-slash': !showPassword }" id="txt_Password_passwordeye"
        @click="togglePasswordVisibility"></div>
      <b-form-invalid-feedback :state="getValidationState(validationContext)">
        {{ $refs.validationState ? $refs.validationState.failedRules.greater_than_0 ? $t("lbl_EMPBE_Smallerthan0") : $refs.validationState.failedRules.email ? $refs.validationState.failedRules.email : $refs.validationState.failedRules.min_value ? $refs.validationState.failedRules.min_value : $t(mandatoryText) : $t(mandatoryText) }}
      </b-form-invalid-feedback>
    </validation-provider>
    <slot name="footer"></slot>
  </div>
</template>
<script>
import { mapGetters } from "vuex";
import { extend } from "vee-validate";
// add custom rules
extend("greater_than_0",{
      validate(value){
        return Number(value) > 0;
      }
    });
export default {
  props: [
    "value",
    "ControlId",
    "isshow",
    "mandatory",
    "title",
    "description",
    "inputStyle",
    "rules",
    "vid",
    "type",
    "isHideStar",
    "CharLimit",
    "disabled",
    "FixedNumCount",
    "isByPassPermission"
  ],
  // , "allowPaste", "allowCopy"
  data() {
    return {
      temp_value: this.value,
      IsShow: true,
      labelText: this.title,
      mandatoryText: this.mandatory,
      validationRules:
        this.rules == null
          ? this.mandatory == null
            ? null
            : { required: true, email: this.type == "email" ? true : false }
          : this.rules,
      floatedLabel: this.checkValue(),
      isinvalid: false,
      showPassword: false,
    };
  },

  computed: {
    ...mapGetters({
      GetPermissionJsonById: "responsePermission/getPermissionJsonById",
    }),
    record() {
      return this.GetPermissionJsonById({ ControlId: this.ControlId });
    },
  },
  mounted() {
    //read from json
    if (this.record != null && !this.isByPassPermission) {
      if (this.record.IsShow != null) this.IsShow = this.record.IsShow;
      if (this.record.IsMandatory) this.validationRules = { required: true };
      if (this.record.IsDisable != null) this.$attrs["disabled"] = this.record.IsDisable;
      if (this.record.Label != null) this.labelText = this.$t(this.record.Label);
      if (this.record.PlaceholderLabel != null)
        this.$attrs["placeholder"] = this.$t(this.record.PlaceholderLabel);
      if (this.record.MandatoryLabel != null)
        this.mandatoryText = this.$t(this.record.MandatoryLabel);
      if (this.record.MaxLength != null) this.$attrs["max"] = this.record.MaxLength;
      if (this.record.MinLength != null) this.$attrs["min"] = this.record.MinLength;
      if (this.record.mutiPermission_IsMandatory != null) {
        switch (localStorage.getItem("currentLangId")) {
          case "1252":
            if (this.record.mutiPermission_IsMandatory.eng) {
              this.validationRules = {
                required: true,
                email: this.type == "email" ? true : false,
              };
            } else {
              this.validationRules = {};
            }
            break;
          case "950":
            if (this.record.mutiPermission_IsMandatory.trad) {
              this.validationRules = {
                required: true,
                email: this.type == "email" ? true : false,
              };
            } else {
              this.validationRules = {};
            }
            break;
          case "936":
            if (this.record.mutiPermission_IsMandatory.simp) {
              this.validationRules = {
                required: true,
                email: this.type == "email" ? true : false,
              };
            } else {
              this.validationRules = {};
            }
            break;
        }
      }
    }
  },
  watch: {
    value() {
      this.temp_value = this.value;
    },
    rules() {
      this.validationRules =
        this.rules == null
          ? this.mandatory == null
            ? null
            : { required: true, email: this.type == "email" ? true : false }
          : this.rules;
      this.mandatoryText = this.mandatory;
    },
    mandatory() {
      this.validationRules =
        this.rules == null
          ? this.mandatory == null
            ? null
            : { required: true, email: this.type == "email" ? true : false }
          : this.rules;
      this.mandatoryText = this.mandatory;
    },
    temp_value(newVal) {
     },
     title(){
      this.labelText = this.title
     }
  },
  methods: {
    
    togglePasswordVisibility() {
      this.showPassword = !this.showPassword;
      const input = this.$refs.validationState.$el.querySelector("input");
      if (this.showPassword) {
        input.type = "text"; // 显示密码
      } else {
        input.type = "password"; // 隐藏密码
      }
    },
    getValidationState({ dirty, validated, valid = null }) {
      this.isinvalid = dirty || validated ? !valid : true;
      return dirty || validated ? valid : null;
    },
    updateValue(e) {
      //Check maxlength
      if (this.$attrs["max"] > 0) {
        this.CheckTextLimit();
      }

      if (this.type === "email" || this.type === "tel" || this.type === "password" || 
          (this.type === "text" && (this.ControlId && (
            this.ControlId.toLowerCase().includes('email') || 
            this.ControlId.toLowerCase().includes('mobile') || 
            this.ControlId.toLowerCase().includes('phone') || 
            this.ControlId.toLowerCase().includes('password') ||
            this.ControlId.toLowerCase().includes('account')
          )))) {
        if (this.temp_value !== null && this.temp_value !== undefined) {
          const stringValue = String(this.temp_value);
          const cleanValue = stringValue.replace(/\s/g, '');
          if (stringValue !== cleanValue) {
            this.temp_value = cleanValue;
            if (this.$refs.input && this.$refs.input.$el) {
              this.$refs.input.$el.value = cleanValue;
            }
          }
        }
      }

      // Clean number inputs - remove 'e', 'E', '+', '-' characters
      if (this.type === "number") {
        if (this.temp_value !== null && this.temp_value !== undefined) {
          const stringValue = this.temp_value.toString();
          if (stringValue.includes('e') || stringValue.includes('E') || stringValue.includes('+') ||(stringValue.includes('-'))) {
            // Remove 'e', 'E', '+' characters
            const cleanValue = stringValue.replace(/[eE+-]/g, '');
            const numValue = parseFloat(cleanValue);
            if (!isNaN(numValue)) {
              this.temp_value = Math.abs(numValue);
            } else {
              this.temp_value = cleanValue;
            }
          }
        }
      }

      if(this.$attrs["NoMultipleMin"] && this.type=="number")
      {
         if(this.temp_value[0]=="0" && this.temp_value.length>0)
         {
          this.$nextTick(() => {
            this.temp_value=0;
          });
         }
      }  
      //只允许整数
      if(this.$attrs["AllowInt"])
      {
        this.$nextTick(() => {
          this.temp_value = parseInt(this.temp_value);
        });
      }
      //限制小数点后几位
      if(this.$attrs["LimitDecimals"] && this.type=='number')
      {
        this.$nextTick(() => {
          const maxLength = parseInt(this.$attrs["LimitDecimals"]);
          const regex = new RegExp(`^\\d*\\.?\\d{0,${maxLength}}$`);

          if (!regex.test(this.temp_value)) {
            this.temp_value =this.temp_value.substring(0,this.temp_value.indexOf('.')+1+maxLength);
          }
          this.$emit("input", this.temp_value);
        });
      }
      //Check char CharOnly
      if (this.CharLimit == "CheckEnglishChar") {
        this.CheckEnglishChar();
      }
      this.$emit("input", this.temp_value);
      this.$emit("CustomChange", this.temp_value);
    },
    handlePaste(event) {
      if (this.type === "email" || this.type === "tel" || this.type === "password" || 
          (this.type === "text" && (this.ControlId && (
            this.ControlId.toLowerCase().includes('email') || 
            this.ControlId.toLowerCase().includes('mobile') || 
            this.ControlId.toLowerCase().includes('phone') || 
            this.ControlId.toLowerCase().includes('password') ||
            this.ControlId.toLowerCase().includes('account')
          )))) {
        event.preventDefault();
        const pastedData = event.clipboardData.getData('text').replace(/\s/g, '');
        this.temp_value = pastedData;
        if (this.$refs.input && this.$refs.input.$el) {
          this.$refs.input.$el.value = pastedData;
        }
        this.$emit("input", pastedData);
        this.$emit("CustomChange", pastedData);
      }
    },
    focusInput() {
      this.floatedLabel = true;
    },
    checkValue() {
      if(typeof this.temp_value === 'number')
      {       
        this.floatedLabel = true;
        this.$emit("input", this.temp_value);
        this.$emit("blur", this.temp_value);

      }else if (typeof this.temp_value === 'string' && this.temp_value != undefined && this.temp_value.length > 0) {
        this.floatedLabel = true;
        this.$emit("input", this.temp_value);
        this.$emit("blur", this.temp_value);
      } else {
        this.floatedLabel = false;
      }
    },
    CheckEnglishChar() {
      this.$nextTick(() => {
        this.temp_value = this.temp_value.replace("®", "");
        var partn = new RegExp("[^\w\s\.\/,-_.:;$+#@?!'%^&℃()~≤≥αβ‰μπφΩΦευ*™\"]", "gi");
        if (partn.exec(this.temp_value)) {
          this.temp_value = this.temp_value.replace(
            /[^\w\s\.\/,-_.:;$+#@?!'%^&℃()~≤≥αβ‰μπφΩΦευ*™\"]/gi,
            ""
          );
          this.$emit("input", this.temp_value);
        }
      });
    },
    CheckTextLimit() {
      this.$nextTick(() => {
        //Check maxlength
        
        if (this.$attrs["max"] > 0) {
          if(this.type=="number")
          {
            if(parseInt(this.temp_value)>this.$attrs["max"])
            {
              this.$swal({
                text: this.$t("lbl_EMPBE_ReachMaxLength_ByNumber"),
                showCancelButton: false,
                confirmButtonText: this.$t("lbl_EMPBE_Confirm"),
              });
              this.temp_value = parseInt(this.$attrs["max"]);
            }
          }
          else
          {
            if (this.temp_value.length > this.$attrs["max"]) {
              this.$swal({
                text: this.$t("lbl_EMPBE_ReachMaxLength"),
                showCancelButton: false,
                confirmButtonText: this.$t("lbl_EMPBE_Confirm"),
              });
              this.temp_value = this.temp_value.slice(0, this.$attrs["max"]);
            }
          }
        }
    
      });
    },
    focusInput() {
      this.$refs.input.focus();
    },
    handleKeydown(event) {
      // Prevent typing 'e', 'E', '+' for all number inputs
      if (this.type === "number" && ['e', 'E', '+'].includes(event.key)) {
        event.preventDefault();
        return;
      }

      // Prevent minus key for all number inputs
      if (this.type === "number" && event.key === "-") {
        event.preventDefault();
        return;
      }
      
    }
  },
};
</script>
<style>
input[type="number"]::-webkit-inner-spin-button,
input[type="number"]::-webkit-outer-spin-button {
  -webkit-appearance: none;
}

.pwd_tips {
  color: #5d4d8c;
  text-align: center;
  position: absolute;
  top: 15px;
  right: 10px;
  cursor: pointer;
}
</style>
